import _createForOfIteratorHelper from "D:\\WORK\\projects\\szn-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createForOfIteratorHelper";
import { DEBUG_BUILD } from '../debug-build.js';
import { logger } from '../logger.js';
import { getFunctionName } from '../stacktrace.js';

// We keep the handlers globally
var handlers = {};
var instrumented = {};

/** Add a handler function. */
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
}

/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(function (key) {
    handlers[key] = undefined;
  });
}

/** Maybe run an instrumentation function, unless it was already called. */
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumentFn();
    instrumented[type] = true;
  }
}

/** Trigger handlers for a given instrumentation type. */
function triggerHandlers(type, data) {
  var typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }
  var _iterator = _createForOfIteratorHelper(typeHandlers),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handler = _step.value;
      try {
        handler(data);
      } catch (e) {
        DEBUG_BUILD && logger.error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat(getFunctionName(handler), "\nError:"), e);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
export { addHandler, maybeInstrument, resetInstrumentationHandlers, triggerHandlers };